import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { spotPriceLoader } from "@/lib/spotSnapshot";
import { jsonLdHeadScript, spotPriceDatasetJsonLd } from "@/lib/structuredData";

const Spotpris = lazy(() => import("@/pages/spotpris/Spotpris"));

export const Route = createFileRoute("/spotpris/")({
  // Spotpriserna hämtas på servern så att tabeller och nyckeltal finns i HTML:en.
  loader: spotPriceLoader,
  head: () => ({
    ...seoHead("/spotpris", { description: "Spotpriset är marknadspriset på el som sätts varje timme av Nord Pool. Här ser du aktuella spotpriser per elområde och förklaringar till hur det fungerar." }),
    // Spotpriserna som Dataset, med elpris-API:t som distribution.
    scripts: [jsonLdHeadScript(spotPriceDatasetJsonLd("/spotpris"))],
  }),
  component: () => <Spotpris />,
});
